import { logoutAccount } from '../../libs/state';
import { parseError } from '../../libs/parser';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Context from '../../provider';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconBenefit from '../../assets/hkdc/icons/NavbarBenefits';
import IconCoupon from '../../assets/hkdc/icons/NavbarCoupon';
import IconFellow from '../../assets/hkdc/icons/NavbarFellow';
import IconFloatBtnEN from '../../assets/hkdc/icons/FloatBtnENIcon';
import IconFloatBtnSC from '../../assets/hkdc/icons/FloatBtnSCIcon';
import IconFloatBtnTC from '../../assets/hkdc/icons/FloatBtnTCIcon';
import IconLogin from '../../assets/hkdc/icons/NavbarLogin';
import IconLogout from '../../assets/hkdc/icons/NavbarLogout';
import IconNews from '../../assets/hkdc/icons/NavbarNews';
import IconProfile from '../../assets/hkdc/icons/NavbarProfile';
import LogoFloatMenu from '../../assets/hkdc/icons/FloatMenuLogo';
import React, { useContext, useEffect, useState } from 'react';
import Slide from '@mui/material/Slide';
import config from '../../config';
import memberApi from '../../libs/api/memberApi';
import './index.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function FootMenuDialog() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { init, me, isMobile, dispatch, floatMenu, lang } = useContext(Context);

    const [open, setOpen] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [tierBenefitsData, setTierBenefitsData] = useState([]);
    const [vouchersData, setVouchersData] = useState([]);

    const fetchTierBenefitsData = async (page) => {
        try {
            const response = await memberApi.getTierBenefits({
                page,
                pageSize: 1
            });
            setTierBenefitsData((prevData) => [...prevData, ...(response?.list ?? []).filter((d) => !(prevData.find((p) => p.uri_name === d.uri_name)))]);
        } catch (error) {
            dispatch({
                type: 'SET_ERROR_DIALOG',
                payload: { open: true, ...parseError(error) }
            });
        }
    };

    const getItem = async (page) => {
        try {
          const response = await memberApi.getItems({
            page,
            pageSize: 1,
            status: 'available'
          });
          setVouchersData((prevData) => [...prevData, ...(response?.list ?? []).filter((i) => !(prevData.find((p) => p.id === i.id)))]);
        } catch (error) {
          dispatch({
            type: 'SET_ERROR_DIALOG',
            payload: { open: true, ...parseError(error) }
          });
        }
    };

    // This page only allow logged in user
    useEffect(() => {
        if (init) {
            fetchTierBenefitsData(1);
            if (me?.status === 'activated'){
                getItem(1);
                setIsLogin(true);
            } else {
                setIsLogin(false);
            }
        }
    }, [init, me, navigate]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const logout = () => {
        logoutAccount({ dispatch });
        navigate(`${config.basename}`);
    };

    const handleNavbarClick = (type) => {
        // eslint-disable-next-line default-case
        switch (type) {
            case 'home':
                navigate(`${config.basename}`, {
                    state: {
                        position: 1
                    }
                });
                break;
            case 'fellow':
                setTimeout(() => {
                    navigate(`${config.basename}${"about-fohkdc"}`);
                }, 200);
                break;
            case 'news':
                navigate(`${config.basename}news`);
                break;
            case 'logout':
                logout();
                break;
            case 'benefits':
                navigate(`${config.basename}`, {
                    state: {
                        toClass: '.benefits-section-cont'
                    }
                });
                break;
            case 'login':
                if (isMobile) {
                    setTimeout(() => {
                        navigate(`${config.basename}${"join-membership-program"}`, {
                          state: {
                            defaultTierId: tierBenefitsData && tierBenefitsData.length > 0 ? tierBenefitsData[0].id : -1,
                            defaultTierType: tierBenefitsData && tierBenefitsData.length > 0 ? tierBenefitsData[0].uri_name.replace('/tier-', '') : ''
                          }
                        });
                      }, 200);
                } else {
                    navigate(`${config.basename}login`);
                }
                break;
            case 'profile':
                navigate(`${config.basename}setting/profile/user`);
                break;
            case 'coupon':
                navigate(`${config.basename}`, {
                    state: {
                        toClass: '.vouchers-section-cont'
                    }
                });
                break;
        }

        handleClose();
    };

    return (
        <React.Fragment>
            <Button style={{ display: floatMenu.show ? undefined : 'none' }} className={`${isMobile ? 'mobile' : 'web'}-float-btn`} aria-label="open dialog menu" onClick={handleClickOpen}>
                {
                    !lang || lang === 'en'
                    ?
                    <IconFloatBtnEN sx={{ fontSize: isMobile ? '4.5rem' : '9rem' }} />
                    :
                    lang === 'tc'
                        ?
                        <IconFloatBtnTC sx={{ fontSize: isMobile ? '4.5rem' : '9rem' }} />
                        :
                        <IconFloatBtnSC sx={{ fontSize: isMobile ? '4.5rem' : '9rem' }} />
                }
            </Button>
            <Dialog
                className={`${isMobile ? 'mobile' : 'web'}-foot-menu`}
                open={open}
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <LogoFloatMenu className="float-menu-logo"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleNavbarClick('home');
                        }}
                    />
                    <CloseIcon className="close-btn" onClick={handleClose} />
                </DialogTitle>
                <DialogContent>

                    {
                        !isLogin &&
                        <>
                            <BottomNavigationAction label={t('nav.about')} icon={<IconFellow />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('fellow');
                                }}
                            />
                            <BottomNavigationAction label={t('nav.news')} icon={<IconNews />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('news');
                                }}
                            />
                            <BottomNavigationAction label={t('nav.benefit')} icon={<IconBenefit />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('benefits');
                                }}
                            />
                            <BottomNavigationAction label={t('nav.login')} icon={<IconLogin />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('login');
                                }}
                            />
                        </>

                    }
                    {
                        isLogin &&
                        <>
                            <BottomNavigationAction label={t('nav.coupon')} icon={<IconCoupon />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('coupon');
                                }}
                            />
                            <BottomNavigationAction label={t('nav.profile')} icon={<IconProfile />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('profile');
                                }}
                            />
                            <BottomNavigationAction label={t('nav.news')} icon={<IconNews />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('news');
                                }}
                            />
                            <BottomNavigationAction label={t('nav.logout')} icon={<IconLogout />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavbarClick('logout');
                                }}
                            />
                        </>

                    }
                </DialogContent>
                <DialogActions>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            window.location.assign('https://www.hkdesigncentre.org/');
                        }}
                    >
                        {t('nav.hkdc')}
                    </span>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}